<template>
  <div>
    <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
      Completá y cargá la factura
    </h6>
    <p
      class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1"
    >
      Subí la factura completa con los siguientes items e importes, podés copiar
      estos datos y pegarlos directamente en la factura que estes completando.
    </p>
    <v-simple-table class="mb-4">
      <template v-slot:default>
        <thead>
          <tr>
            <th
              class="text-subtitle-2 text-md-subtitle-1 text-left grey--text text--darken-1 font-weight-bold"
            >
              Detalle
            </th>
            <th
              class="text-subtitle-2 text-md-subtitle-1 text-right grey--text text--darken-1 font-weight-bold"
            >
              Monto
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in formData.transactions" :key="index">
            <td class="text-subtitle-2 text-md-subtitle-1 font-weight-regular">
              {{ item.request_id }} {{ item.service }}
            </td>
            <td
              class="text-subtitle-2 text-md-subtitle-1 text-right font-weight-medium"
            >
             $ {{ item.amount }}
            </td>
          </tr>
          <tr>
            <td
              class="text-subtitle-2 text-md-subtitle-1 text-uppercase font-weight-bold"
            >
              Total
            </td>
            <td
              class="text-subtitle-2 text-md-subtitle-1 text-right font-weight-bold"
            >
             $ {{ totalAmount }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="formData?.invoice !== null" class="mb-10">
      <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
        Factura cargada
      </h6>
      <v-card class="mt-6" elevation="0">
        <v-row class="d-flex align-center pl-4 pr-5">
          <v-col cols="10" sm="10" md="9" class="d-flex pa-0" style="width: 100%">
            <v-card-text class="d-flex pa-0 align-center"
            >
              <v-icon
                style="background-color: #d32f2f"
                class="pa-2 rounded-lg mr-2"
                color="white"
                >description</v-icon
              >
              <span
                class="blue--text text--darken-2 font-weight-medium text-subtitle-1 text-md-h6 short-text"
                style="cursor: pointer"
                @click="openPDFInNewTab"
                >{{ formData.invoice.name }}</span
              ></v-card-text
            >
          </v-col>
          <v-col cols="2" sm="2" md="3" class="pa-0 pr-md-9">
            <v-card-text
              class="d-flex justify-end align-center pa-0 text-subtitle-1 text-md-h6 grey--text text--darken-1"
              ><v-btn @click="removeFile" icon
                ><v-icon>delete_outline</v-icon></v-btn
              ></v-card-text
            >
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div v-else>
      <input
        accept="application/pdf"
        type="file"
        class="d-none"
        ref="imageUploader"
        @change="handleChange"
      />
      <v-btn
        type="button"
        large
        @click="handleClick"
        block
        class="blue darken-2 white--text mb-4"
      >
        <v-icon>attach_file</v-icon> subir factura
      </v-btn>
      <p
        v-if="invoiceErrors?.length"
        class="subtitle-1 red--text darken-4 font-weight-medium"
      >
        {{ invoiceErrors[0] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThirdStep",
  props: ["formData", "v"],
  data: () => ({
    file: [],
  }),
  computed: {
    invoiceErrors() {
      const errors = [];
      if (!this.v.invoice.$error) return errors;
      !this.v.invoice.required && errors.push("Debe cargar una imagen");
      return errors;
    },
    totalAmount() {
      return this.formData.transactions
        .reduce((total, item) => total + parseFloat(item.amount || 0), 0)
        .toFixed(2);
    },
  },
  methods: {
    handleClick() {
      this.$refs.imageUploader?.click();
    },
    handleChange() {
      this.file = this.$refs.imageUploader?.files[0];
      if (this.file == null) return;
      this.$emit("updateFile", this.file);
    },
    removeFile() {
      this.file = null;
      this.$emit("updateFile", this.file);
    },
    openPDFInNewTab() {
      if (this.file) {
        const blobUrl = URL.createObjectURL(this.file);
        window.open(blobUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
th,
td {
  border-bottom: none !important;
}
</style>
